import { connect } from 'react-redux';
import { setPageTitle } from '../layout/layout.actions';
import { withRouter } from 'react-router-dom';
import React, { PureComponent } from 'react';

import Grid from '@material-ui/core/Grid';
import ReportCard from './reportCard.component';

import { reports } from './reportDefinitions.js';
import { userHasPermission, isSamsungClient, isMPCClient, isCRHClient, isFincantieriMarineClient } from '../../utilities/authUtils';

class ContactsContainer extends PureComponent {
  constructor(props) {
    super(props);
    props.setPageTitle('My Reporting');
    this.handleNavigation = this.handleNavigation.bind(this);
  }

  handleNavigation(link) {
    if (link) {
      this.props.history.push(`reporting/${  link}`);
    } else {
      this.props.history.push('reporting');
    }
  }

  render() {
    let { clientDivisions } = this.props;

    return (
      <div style={{ padding: '2rem' }}>
        <Grid container spacing={3} style={{
          rowGap: '0rem',
        }}>
          {reports.map((report, i) => {
            // show coming soon but don't hide card altogether for certain reports
            let { showComingSoon } = report;
            let isAuthorized = false;

            // check for permission-specific report and dont show unless permissionName matches
            if (report.permissionName) {
              if (!userHasPermission(report.permissionName, clientDivisions)) {
                // could not find required permission for report
                if (!showComingSoon) {
                  return null;
                }
              } else {
                isAuthorized = true;
              }
            }

            // Added via AB#2075 to handle custom "CRH Americas Materials" Client reporting requests/requirements.
            // Hide the standard "Transferee Expenses" report so that we are only displaying the Custom CRH version of that report.
            if (isCRHClient() === true && report.link === 'transfereeexpense') {
              return null;
            }

            // Added via AB#1356 to handle custom Samsung reporting requests/requirements.
            // Hide the standard cost report so that we can display the Custom Samsung Cost Report in its place.
            if (isSamsungClient() === true && report.link === 'costreport') {
              return null;
            }

            // Added via AB#2053 to handle custom MPC reporting requests/requirements.
            // Hide the standard "Cost" report and "Transferee Expenses" report so that we are only displaying the Custom MPC versions of those reports.
            if (isMPCClient() === true && (report.link === 'costreport' || report.link === 'transfereeexpense')) {
              return null;
            }

            // Added via AB#2096 to handle custom Fincantieri Marine reporting requests/requirements.
            // Hide the standard "Cost" report so that we are only displaying the Custom Fincantieri Marine version of this report.
            if (isFincantieriMarineClient() === true && report.link === 'costreport') {
              return null;
            }
            
            return (
              <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                <ReportCard key={i} report={report} showComingSoon={showComingSoon && !isAuthorized} handleNavigation={this.handleNavigation} />
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contacts: state.contacts.get('contacts'),
    clientDivisions: state.layout.get('clientDivisions'),
  };
};

export default withRouter(connect(mapStateToProps, {
  setPageTitle,
})(ContactsContainer));
